/**
 * Translate description: Index page for target actions
 */

import { useEffect, useContext } from 'react';

import { langByCode, useLanguageContext } from "../../context/LanguageContext";
import AppContext from '../../context/AppContext';
import InfoContext from '../../context/InfoContext';
import AppProvider from '../../provider/AppProvider';

import Bread from '../../components/layout/BreadCrumbs';
import Title from '../../components/layout/Title';

import Typography from '@mui/joy/Typography';

import Content from './components/Content';


import { Crud } from '../../utils/crud';

const crud = new Crud('target_actions');

function _Index() {
  const { t } = useLanguageContext();

  const { setInfo } = useContext(InfoContext);
  const { setListItems } = useContext(AppContext);
  const { paginator, setPaginator } = useContext(AppContext);
  const { sorting } = useContext(AppContext);
  const { filter, setFilter } = useContext(AppContext);
  const { loading, setLoading } = useContext(AppContext);
  const { currentLang } = useContext(AppContext);

  useEffect(() => {
    if (currentLang) {
      setFilter({ ...filter })
    }
  }, [currentLang]);

  useEffect(() => {
    const loadTable = async () => {
      // if (loading) return;
      setLoading(true);
      let list = await crud.get({ paginator, sorting, filter })
      if (list.is_error) {
        setInfo({ type: 'danger', show: true, message: `${t('Error')}` });
        setTimeout(() => setInfo({ show: false }), 6000)
        setLoading(false);
        return;
      }
      setLoading(false);
      setListItems(list.data);
      setPaginator({ ...paginator, totalPages: list.pages, cnt: list.cnt });
    }
    loadTable();
  }, [paginator.currentPage, filter.type_id, filter.path?.value, filter.date_range?.to, filter.date_range?.from, sorting]);


  return (
    <>
      <Bread path={[{ name: t("Analytics") }, { name: t("Target Actions") }]} />
      <Title>
        <Typography level="h2" component="h1">{t("Target Actions")}</Typography>
      </Title>
      <Content />
    </ >
  );
}

export default function Index() {
  return (
    <AppProvider>
      <_Index />
    </AppProvider>
  );
}